/* ============================================================
   samenspel.js — markeert welke stap van de dag op dit moment ter hoogte van
   de olie staat, en zet de stip op de lijn ertussen.

   Wat dit bestand WEL doet: één keer per beeldverversing de middens van de
   stappen vergelijken met het midden van de olie, de dichtstbijzijnde stap
   `data-actief` geven en de stip daarheen schuiven (als CSS-variabele; de
   verplaatsing zelf is een transform in samenspel.css).

   Wat dit bestand NIET doet: de scroll overnemen. Sticky is CSS. Er wordt
   nergens een scroll-event afgebroken en nergens `scrollTo` aangeroepen; de
   pagina blijft een pagina, ook met een toetsenbord of een schermlezer.

   WANNEER HET AANSTAAT. Alleen vanaf 1024 px — daaronder staan de kolommen
   onder elkaar en is er geen "ter hoogte van" — en alleen als de bezoeker geen
   "minder beweging" heeft aanstaan. In alle andere gevallen blijft de sectie
   in de stille stand van samenspel.css en is er niets stuk.

   HET ANKER. Het midden van de vastgeklemde olie, niet het midden van het
   scherm: de olie staat onder de kop van de winkel en de bezoeker kijkt náást
   het product, niet naar het scherm als geheel. Staat er geen olie (de sectie
   kan ook alleen met stappen bestaan), dan is het anker het midden van het
   venster en doet de stip niets — er is dan geen lijn.
   ============================================================ */
(function () {
  'use strict';
  if (window.__samenspel) return;   // de sectie laadt zijn eigen script; twee keer is niets
  window.__samenspel = true;

  var stil = window.matchMedia('(prefers-reduced-motion: reduce)');
  var breed = window.matchMedia('(min-width: 1024px)');

  function Samenspel(wortel) {
    this.wortel = wortel;
    this.toneel = wortel.querySelector('.samenspel__toneel');
    this.vast = wortel.querySelector('[data-samenspel-vast]');
    this.stip = wortel.querySelector('.samenspel__stip');
    this.stappen = [].slice.call(wortel.querySelectorAll('[data-samenspel-stap]'));
    this.actief = null;
    this.wacht = false;
    this.aan();
  }

  Samenspel.prototype.stap = function () {
    this.wacht = false;
    if (!this.wortel.classList.contains('samenspel--loopt') || !this.stappen.length) return;

    // Het anker: het midden van de olie zoals hij nú staat (vastgeklemd of
    // niet), en anders het midden van het venster.
    var anker;
    if (this.vast) {
      var v = this.vast.getBoundingClientRect();
      anker = v.top + v.height / 2;
    } else {
      anker = window.innerHeight / 2;
    }

    var beste = null, besteAfstand = Infinity, besteMidden = 0;
    for (var i = 0; i < this.stappen.length; i++) {
      var r = this.stappen[i].getBoundingClientRect();
      var midden = r.top + r.height / 2;
      var afstand = Math.abs(midden - anker);
      if (afstand < besteAfstand) {
        besteAfstand = afstand;
        beste = this.stappen[i];
        besteMidden = midden;
      }
    }

    if (beste !== this.actief) {
      if (this.actief) this.actief.removeAttribute('data-actief');
      if (beste) beste.setAttribute('data-actief', '');
      this.actief = beste;
    }

    // De stip staat op de hoogte van het midden van de actieve stap, gemeten
    // vanaf de bovenkant van het toneel (daar staat de lijn absoluut in).
    if (this.stip && this.toneel && beste) {
      var t = this.toneel.getBoundingClientRect();
      this.stip.style.setProperty('--stip-y', Math.round(besteMidden - t.top) + 'px');
    }
  };

  Samenspel.prototype.plan = function () {
    if (this.wacht) return;
    this.wacht = true;
    var zelf = this;
    requestAnimationFrame(function () { zelf.stap(); });
  };

  Samenspel.prototype.aan = function () {
    var zelf = this;
    if (!this._plan) this._plan = function () { zelf.plan(); };

    // De loopstand is van JS, en alleen breed en alleen met beweging.
    if (stil.matches || !breed.matches) { this.uit(); return; }
    if (this.wortel.classList.contains('samenspel--loopt')) return;

    this.wortel.classList.add('samenspel--loopt');
    addEventListener('scroll', this._plan, { passive: true });
    addEventListener('resize', this._plan, { passive: true });
    this.stap();
  };

  Samenspel.prototype.uit = function () {
    removeEventListener('scroll', this._plan);
    removeEventListener('resize', this._plan);
    this.wortel.classList.remove('samenspel--loopt');
    if (this.actief) this.actief.removeAttribute('data-actief');
    this.actief = null;
    if (this.stip) this.stip.style.removeProperty('--stip-y');
  };

  /* ---------- opstarten ---------- */

  var lopend = [];

  function start(bereik) {
    var wortels = (bereik || document).querySelectorAll('[data-samenspel]');
    [].forEach.call(wortels, function (w) {
      if (w.__samenspel) return;
      w.__samenspel = true;
      lopend.push(new Samenspel(w));
    });
  }

  start();

  // De bezoeker zet "minder beweging" aan of uit, of draait het scherm over de
  // grens van 1024 px, terwijl de pagina openstaat.
  var wissel = function () { lopend.forEach(function (s) { s.aan(); }); };
  [stil, breed].forEach(function (mq) {
    if (mq.addEventListener) mq.addEventListener('change', wissel);
    else if (mq.addListener) mq.addListener(wissel);
  });

  // De thema-editor plaatst en herlaadt secties zonder de pagina te verversen.
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    lopend = lopend.filter(function (s) {
      if (e.target.contains(s.wortel)) { s.uit(); return false; }
      return true;
    });
  });
})();
